import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const EmailTemplateService = {
  async getById(recordId) {
    return await ApiService.get(`api/EmailTemplate/${recordId}`);
  },

  async getPlaceholderDefinitions(documentTypeRecordId) {

    const requestFeatureData = {
      url: "api/EmailTemplatePlaceholderDefinitionList",
      filter: `EmailTemplateDocumentTypeRecordID eq ${documentTypeRecordId} and Inactive eq 'N'`,
      orderby: "Sequence",
    };

    return await ApiService.oDataGet(requestFeatureData);
  },

  async getDocumentTypes() {
    return await ApiService.oDataGet({
      url: "api/EmailTemplateDocumentTypeList",
      filter: "Inactive eq 'N'",
      orderby: "Sequence",
    });
  },

  async save(payload) {
    ApiService.setHeaders();
    return await ApiService.post("api/Save_EmailTemplate", payload);
  },

  async inactivate(recordId) {
    ApiService.setHeaders();
    return await ApiService.post(
      `api/EmailTemplate/${recordId}/Inactivate`,
      {},
      "String",
    );
  },

  async reactivate(recordId) {
    ApiService.setHeaders();
    return await ApiService.post(
      `api/EmailTemplate/${recordId}/Reactivate`,
      {},
      "String",
    );
  },
};

export default EmailTemplateService;
export { EmailTemplateService };
